import { Component, Input } from "@angular/core";
import { GatewayView } from "../gateway-view";
import { Gateway } from "@impulse/sdp-shared-models";

@Component({
	selector: "sdp-gateway-table-ports",
	template: `<p *ngFor="let portList of ports">{{ portList.join(', ') }}</p>`
})
export class GatewayTablePortsComponent {
	@Input()
	public gateway?: GatewayView;

	/**
	 * @returns an array of just the ports from the private gateway, or an empty array if no such data is mapped to this component
	 */
	public get ports(): Gateway.Port[][] {
		if (!!this.gateway && !!this.gateway.hostAndPorts) {
			return this.gateway.hostAndPorts.map((hostAndPort) => {
				return [
					hostAndPort.openvpnPort,
					hostAndPort.fwknopPort
				];
			});
		} else {
			return [];
		}
	}
}
